export default __webpack_public_path__ + "static/media/kitchen-main-category.09a81387.jpeg";